export default {
  projectDesc: 'A powerful selector for <strong>Vue2</strong>, list or table view of pagination, <br>' +
  'use tags for multiple selection, i18n and server side resources supports',
  demo: {
    desc: 'single, multiple select mode and list, table view mode',
    single: 'Single select mode',
    custom: 'Custom row content and disabled/enabled plugin',
    nopage: 'Close pagination bar',
    modify: 'Dynamic change selected items',
    multiple: 'Multiple select mode, limited 3 max selected items and dynamic change data source',
    tbSingle: 'Show by table view - single select',
    tbMultiple: 'Show by table view - multiple select',
    server: 'Server side data mode',
    serverResponse: 'Server side response data sample',
    btnDisabled: 'disabled plugin',
    btnEnabled: 'enabled plugin',
    btnModify: 'change selected items',
    btnChange: 'change data source',
    useful: 'Useful case',
    datasource: 'data source',
    format: 'and format data to Array',
    countries: 'Countries of the world',
    timezones: 'World time zone',
    valuesEvent: '<code>values</code> event return selected items raw data',
    rtl: 'drop down container layer and inner content align to the right'
  },
  option: {
    'v-model': 'current selected items value, the value corresponding <code>keyField</code> option specified field. in the case of multiple selection, values used "," to separated, example: "3,5,7"',
    data: 'the data source set.string type to specified server side url.<br>in server side mode, must config ' +
      '<code>dataLoad</code> function to set server side handler, and config <code>result-format</code> option to format result',
    keyField: 'specified the field as key field',
    showField: 'string type to specified content field. also can set function type to custom row content',
    tbColumns: 'table view columns config, the format like:',
    sort: 'the list sort config. format: "field sort_type", user space to split<br><code>asc</code>: ascending sort，<code>desc</code>: descending sort',
    searchField: 'server side search field. if no specified, will using "showField" field, the option only work on server side',
    params: 'the custom parameters send to server side',
    resultFormat: 'the response data format function in server side mode, must return data format like:',
    selected: 'init selected items. the content will match to "keyField" field. in multiple mode use "," to split codes, example: <code>1,2,3</code>',
    title: 'the default title text in header bar',
    placeholder: 'the short hint is displayed when no items selected',
    maxSelectLimit: 'the max selected limited in multiple select mode',
    multiple: 'multiple select mode, the selected item will be shown as tag',
    pagination: 'whether close pagination bar',
    disabled: 'Disabled plugin. <code>true</code> disabled <code>false</code> enabled',
    width: 'set drop down container layer width, if not set, the drop down container layer width will adaptive by inner content',
    rtl: 'set drop down container layer and inner content align to the right, to adapt to the needs of some countries/language to the right'
  },
  event: {
    values: 'return selected rows data',
    removed: 'return removed rows data'
  },
  api: {
    desc: 'Before calling the plugin API, need to specified <code>ref</code> attribute and call API like : <code>this.$refs.xxx</code>',
    remove: 'clear all selected items'
  }
}
